(function () {
  'use strict';

  /* @ngdoc object
   * @name teams.team
   * @description
   *
   */
  angular
    .module('neo.home.teams.team', [
      'ui.router'
    ]);
}());
